/* eslint-disable no-unused-vars */
import type { Editor } from '@tencent/alloy-editor';
import type { IEditorProps } from './editor-props.interface';
import type { IAllStyles, IBodyStyle, IParagraphStyle, ITextBodyStyle, ITextRunStyle } from './editor-styles.interface';
import type { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import type { IParagraph } from './editor-para.interface';


/**
 * Editor默认宽高，单位px
 */
export const EDITOR_DEFAULT_WIDTH = 300;
export const EDITOR_DEFAULT_HEIGHT = 200;

export interface IEditorView {
    /**
     * 获取显示的Editor
     */
    getAlloyEditor: () => Editor;

    /**
     * 获取调用方传递的参数
     */
    getProps: () => IEditorProps;

    /**
     * 获取文本绘制区域
     */
    getTextRect: () => IRect;

    /**
     * 获取编辑器 readOnly 状态
     */
    isReadOnly: () => boolean

    /**
     * 获取 app 偏移量
     */
    getAppPosition: () => { x: number, y: number }

    updateChangeFlag: (changeFlag: boolean) => void;

    /**
     * 触发 sdk 保存数据
     */
    onChange: IEditorProps['onChange']
    getEditorHeightByParagraphList: (paragraphList: IParagraph[], bodyStyle?: IBodyStyle) => number;
    getAllStylesSync: () => IAllStyles;
    isExpanded: () => boolean;
}

/**
 * 查找替换相关数据
 */
export interface SearchInfo {
    isSearchingFlag?: boolean,
    searchResult?: [],
    isHighlightFlag?: boolean,
    highlightResult?: [],
    keyword: string,
}

export interface ITextRect {
    left: number;
    top: number;
    width: number;
    height: number;
}

export interface IRect {
    x: number;
    y: number;
    width: number;
    height: number;
}

/**
 * 段落以及所属段落的textRun样式集合
 */
export interface ParaRunStyles {
    paraStyle: IParagraphStyle;
    runStyleList: ITextRunStyle[];
}

export interface EditorStyles {
    textBodyStyle: ITextBodyStyle,
    paraStyleList: ParaRunStyles[],
}

export interface IMeasureSizeProps {
    modelKey: string,
    textRect: ITextRect,
    isTitle: boolean,
    textBodyStyle: {
        autoFitType?: string,
        wrapperStyle?: {
            textDirection?: TextDirectionType,
        }
    }
}

export interface IMeasureBlockSizeProps {
    textRect: ITextRect,
    textBodyStyle: {
        wrapperStyle?: {
            textDirection?: TextDirectionType,
        }
    }
}

export interface IMeasureInlineSizeProps {
    textBodyStyle: {
        wrapperStyle?: {
            textDirection?: TextDirectionType,
        }
    }
    textRect: ITextRect,
}

export interface IBatchMeasureBlockSizeProps {
    width?: number,
    height?: number,
    paragraphList: IParagraph[];
    textBodyStyle: ITextBodyStyle;
}

// "路径"，[段落索引, 文本(textRun)节点索引]
export type IPath = [number, number];
// "点"，"路径 + 偏移"即点的位置
export interface IPoint {
    path: IPath;
    offset: number;
}
// "范围"，anchor为起始点，focus为终点，其前后顺序由选中文本的姿势决定
export interface IRange {
    anchor: IPoint;
    focus: IPoint;
}
// "选区"，数据类型依据 Editor中的BaseSelection
export type ISelection = IRange | null;
